import axios from 'axios';
import { Fornitor_table_interface } from '@bludata/common-interfaces';
import { getQueryCachingObject } from '@bludata/utility-functions';
import ReactQueryInstance from '../../utility_objects/ReactQueryInstance';
import { SortObject, FilterObject } from '@bludata/hook-usetableloader';

export const fetchListaFornitoriAttivi = () => {
  return new Promise<Fornitor_table_interface[]>((resolve, reject) => {
    const sorters: SortObject[] = [
      {
        property: 'ragioneSociale',
        direction: 'ASC',
      },
    ];
    const filters: FilterObject[] = [
      {
        operator: '=',
        property: 'attivo',
        value: true,
      },
    ];
    const cacheObject = getQueryCachingObject(
      'fornitorelista',
      filters,
      sorters
    );

    const cachedData: Fornitor_table_interface[] =
      ReactQueryInstance.getQueryData(cacheObject.queryKey);

    if (cachedData) {
      resolve(cachedData);
    } else {
      axios
        .get('/focusapi/tabella/fornitorelista', {
          params: {
            _dc: new Date().getTime(),
            sort: JSON.stringify(sorters),
            filter: JSON.stringify(filters),
          },
        })
        .then((response) => {
          let listaFornitori = response.data.data;
          const success = response.data.success;

          if (success) {
            ReactQueryInstance.setQueryData(
              cacheObject.queryKey,
              listaFornitori
            );
            resolve(listaFornitori);
          } else {
            reject();
          }
        })
        .catch(() => {
          reject();
        });
    }
  });
};
